import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { getActions } from '../../global';
import Loading from '../ui/Loading';
import './ChangeEmailPage.scss';

const ChangeEmailPage: React.FC = () => {
  const { changeEmailAction } = getActions();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const email = searchParams.get('email');

    console.log(token, email);

    if (token && email) {
      changeEmailAction({
        new_email: email,
        hash: token,
        onClose: () => {},
        navigate,
      });
    } else {
      navigate('/');
    }
  }, [])

  return (
    <div className='delete-account-wrapper'>
      <div className='qr-loading'>
        <Loading />
      </div>
    </div>
  );
};

export default ChangeEmailPage;
